'use client';

import { AttributeGeneric } from '@eliadmin/core/src/components/categories/attributes/attribute-generic';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductAvailability() {
  return (
    <div className={cn('product-availability', 'hidden sm:block')}>
      <AttributeGeneric type="availability" type2="availabilities" />
    </div>
  );
}
